// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","inner":"Footer_inner__CVEiR","copy":"Footer_copy__V37yO","links":"Footer_links__wMgLO"};